// ── Metabar dropdowns (<details>) ───────────────────────────────────
(function () {
    'use strict';

    var metabar = document.querySelector('.metabar');
    if (!metabar) return;
    var allDetails = metabar.querySelectorAll('details');

    // Close sibling dropdowns when one opens (mutual exclusion)
    allDetails.forEach(function (d) {
        d.addEventListener('toggle', function () {
            if (d.open) {
                allDetails.forEach(function (other) {
                    if (other !== d) other.removeAttribute('open');
                });
            }
        });
    });

    // Close all dropdowns on click outside + Escape key
    document.addEventListener('click', function (e) {
        allDetails.forEach(function (d) {
            if (d.open && !d.contains(e.target)) d.removeAttribute('open');
        });
    });
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            allDetails.forEach(function (d) {
                if (d.open) {
                    d.removeAttribute('open');
                    d.querySelector('summary').focus();
                }
            });
        }
    });
})();
